<i2g-dialog-base
  [icon]="icon"
  [title]="title"
  [body]="body"
  [primaryButtonText]="primaryButtonText"
  [primaryButtonStyle]="primaryButtonStyle"
  [secondaryButtonText]="secondaryButtonText"
  [disablePrimaryButton]="disablePrimaryButton"
  [disableSecondaryButton]="disableSecondaryButton"
  (primaryButtonClicked)="onPrimaryButtonClicked()"
  (secondaryButtonClicked)="onSecondaryButtonClicked()"
></i2g-dialog-base>
